import { recordGA4Event } from '@components/services/analytics/ga4'
import { getCategories, getCurrentPage } from '@framework/utils/app-util'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { isMobileOnly } from 'react-device-detect'

interface IExchangeItemProps {
  item: any
  previousPath?: string
}

export const handleReturnExchangeItemClickGAEvent = (
  props: IExchangeItemProps
) => {
  const { item, previousPath } = props
  recordGA4Event(window, GA_EVENT.RETURN_EXCHANGE_CLICK, {
    current_page: getCurrentPage(),
    previous_page: getCurrentPage(previousPath),
    device: isMobileOnly ? 'Mobile' : 'Desktop',
    items: [
      {
        item_name: item?.name,
        item_category2: getCategories(item).category2,
        item_category: getCategories(item).category,
        item_variant: item?.colorName,
        color: item?.colorName,
        item_id: item?.productId,
        price: item?.price?.raw?.withTax,
        item_var_id: item?.stockCode,
        item_list_name: getCategories(item).category,
      },
    ],
  })
}
